
import UnitMap from './facades/UnitMap'

module.exports = function unitmap (element, options) {
  return new UnitMap(element, options)
}
